export default __webpack_public_path__ + "static/media/fasad11.b367bd5c.jpeg";